$(function () {
    // Initiate slickjs on horizontal record spotlight cartridges & other carousels
    $('.slick-carousel').each(function () {
        var $carousel = $(this);
        var $slides = $(this).find('.carousel-slides');
        var $pages = $(this).find('.carousel-page-info');
        var slideLength = $slides.find('.item').length;
        var slideCount = $slides.data('columns');
        var mobileSlideCount = $slides.data('mobile-columns');
        var tabletSlideCount = $slides.data('tablet-columns');
        var xsSlideCount = $slides.data('xs-columns');
        var smSlideCount = $slides.data('sm-columns');
        var mdSlideCount = $slides.data('md-columns');
        var lgSlideCount = $slides.data('lg-columns');
        var xlSlideCount = $slides.data('xl-columns');
        var totalPages = getSlidePageCount(slideLength, slideCount, mobileSlideCount, tabletSlideCount, xsSlideCount, smSlideCount, mdSlideCount, lgSlideCount, xlSlideCount);
        var defaultCount = getDefaultCount(slideCount, mobileSlideCount, tabletSlideCount, xsSlideCount, smSlideCount, mdSlideCount, lgSlideCount, xlSlideCount);
        // Update pagination information
        $pages.find('.current').html(1);
        $pages.find('.total').html(totalPages);

        // Default options
        var settings = {
            arrows: true,
            rows: 0,
            slidesToShow: defaultCount,
            slidesToScroll: defaultCount,
            prevArrow: '<a class="carousel-arrow prev"><i class="fa fa-angle-left"></i></a>',
            nextArrow: '<a class="carousel-arrow next"><i class="fa fa-angle-right"></i></a>',
            responsive: [],
            infinite: false
        };

        // Extra small screen size.
        if (typeof xsSlideCount !== 'undefined') {
            settings.responsive.push({
                breakpoint: 576,
                settings: {
                    slidesToShow: xsSlideCount,
                    slidesToScroll: xsSlideCount
                }
            });
        }

        // mobile or small
        if (typeof mobileSlideCount !== 'undefined' || typeof smSlideCount !== 'undefined') {
            settings.responsive.push({
                breakpoint: 768,
                settings: {
                    slidesToShow: mobileSlideCount || smSlideCount,
                    slidesToScroll: mobileSlideCount || smSlideCount
                }
            });
        }

        // tablet or medium
        if (typeof tabletSlideCount !== 'undefined' || typeof mdSlideCount !== 'undefined') {
            settings.responsive.push({
                breakpoint: 992,
                settings: {
                    slidesToShow: tabletSlideCount || mdSlideCount,
                    slidesToScroll: tabletSlideCount || mdSlideCount
                }
            });
        }

        // Large screen size
        if (typeof lgSlideCount !== 'undefined') {
            settings.responsive.push({
                breakpoint: 1280,
                settings: {
                    slidesToShow: lgSlideCount,
                    slidesToScroll: lgSlideCount
                }
            });
        }

        // Extra large screen size
        if (typeof xlSlideCount !== 'undefined') {
            settings.responsive.push({
                breakpoint: 4000, // cover > large
                settings: {
                    slidesToShow: xlSlideCount,
                    slidesToScroll: xlSlideCount
                }
            });
        }

        // Fire methods to update pagination and such.
        var currentPage = 1;
        $slides.on('init', function (event, slick) {
            if (totalPages > 0) {
                $pages.addClass('show');
            }

            // Update last slide class
            addClasses($(this));
        });

        $slides.on('afterChange', function (event, slick, currentSlide) {
            var current = $carousel.attr('data-current-slide');
            current = (typeof current == 'undefined' ? 0 : parseInt(current, 10));
            var direction = (current < currentSlide ? 'right' : 'left');

            // This gets triggered on breakpoint sometimes too so have this check so page information stays the same if it's actually the same
            if (current !== currentSlide) {
                currentPage = updatePageInfo($pages, currentPage, totalPages, direction);
                $carousel.attr('data-current-slide', currentSlide);

                // Update last slide class
                addClasses($(this));
            }
        });

        $slides.on('breakpoint', function () {
            // Update page information
            totalPages = getSlidePageCount(slideLength, slideCount, tabletSlideCount, mobileSlideCount, xsSlideCount, smSlideCount, mdSlideCount, lgSlideCount, xlSlideCount);

            $pages.find('.current').html(1);
            $pages.find('.total').html(totalPages);

            currentPage = 1; // Reset page

            // Update last slide class
            addClasses($(this));
        });

        // Update pagination information on click and swipe.
        $slides.on('swipe', function (event, slick, direction) {
            if (direction == 'left') {
                if (currentPage == totalPages) {
                    return; // can't swipe into a page that doesn't exist
                }
            } else {
                if (currentPage == 1) {
                    return; // can't swipe backwards from first page
                }
            }
            // Update last slide class
            addClasses($(this));
        });

        // Initiate slider
        $slides.slick(settings);
    });
});

/**
 * Get number of pages.
 *
 * @param slideCount int    How many slides are in the carousel
 * @param desktopCount int  How many to show on desktop
 * @param tabletCount int   How many to show on tablet (optional)
 * @param mobileCount int   How many to show on mobile (optional)
 *
 * @return int
 */
function getSlidePageCount(slideCount, desktopCount, tabletSlideCount, mobileSlideCount, xsSlideCount, smSlideCount, mdSlideCount, lgSlideCount, xlSlideCount) {
    // Check screen resolution.
    var $screenWidth = $(window).width();
    var count = Math.ceil(slideCount / parseInt(desktopCount, 10)); // Default pages - show desktop

    if ($screenWidth < 576 && typeof xsSlideCount !== 'undefined') {
        // extra small screen
        count = Math.ceil(slideCount / parseInt(xsSlideCount, 10));
    }
    if ($screenWidth < 768 && (typeof mobileSlideCount !== 'undefined' || typeof smSlideCount !== 'undefined')) {
        // mobile or small
        count = Math.ceil(slideCount / parseInt((mobileSlideCount || smSlideCount), 10));
    }
    else if ($screenWidth < 992 && (typeof tabletSlideCount !== 'undefined' || typeof mdSlideCount !== 'undefined')) {
        // tablet or medium
        count = Math.ceil(slideCount / parseInt((tabletSlideCount || mdSlideCount), 10));
    }
    else if ($screenWidth < 1280 && typeof lgSlideCount !== 'undefined') {
        // large screen
        count = Math.ceil(slideCount / parseInt(lgSlideCount, 10));
    }
    else if ($screenWidth > 1280 && typeof xlSlideCount !== 'undefined') {
        // extra large screen
        count = Math.ceil(slideCount / parseInt(xlSlideCount, 10));
    }

    return count;
}

function getDefaultCount(desktopCount, tabletSlideCount, mobileSlideCount, xsSlideCount, smSlideCount, mdSlideCount, lgSlideCount, xlSlideCount) {
    // Check screen resolution.
    var $screenWidth = $(window).width();

    if ($screenWidth < 576 && typeof xsSlideCount !== 'undefined') {
        // extra small screen
        count = parseInt(xsSlideCount, 10);
    }
    if ($screenWidth < 768 && (typeof mobileSlideCount !== 'undefined' || typeof smSlideCount !== 'undefined')) {
        // mobile or small
        count = parseInt((mobileSlideCount || smSlideCount), 10);
    }
    else if ($screenWidth < 992 && (typeof tabletSlideCount !== 'undefined' || typeof mdSlideCount !== 'undefined')) {
        // tablet or medium
        count = parseInt((tabletSlideCount || mdSlideCount), 10);
    }
    else if ($screenWidth < 1280 && typeof lgSlideCount !== 'undefined') {
        // large screen
        count = parseInt(lgSlideCount, 10);
    }
    else if ($screenWidth > 1280 && typeof xlSlideCount !== 'undefined') {
        // extra large screen
        count = parseInt(xlSlideCount, 10);
    } else {
    	count = desktopCount;
    }

    return count;
}

/**
 * Update current page information.
 *
 * @param pages DOMElement   Div that holds paging information
 * @param current int        Current page
 * @param total int          Total amount of pages
 * @param direction string   Direction they clicked/swiped
 *
 * @return int
 */
function updatePageInfo(pages, current, total, direction) {
    if (direction === 'right') {
        current = (current === total ? 1 : current + 1);
    } else if (direction === 'left') {
        current = (current === 1 ? total : current - 1);
    }
    pages.find('.current').html(current);
    return current;
}

/**
 * Add/update classes in slider.
 *
 * @param $slider DOMElement    Div that the slider is attached to
 *
 * @return void
 */
function addClasses($slider) {
    // Remove old classes
    $slider.find('.slick-active').removeClass('last');

    // Add new classes
    $slider.find('.slick-active').filter(':last').addClass('last');
    $slider.find('.slick-active').filter(':last').removeClass('border-right');
}
